import { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { connect } from "../../redux/blockchain/blockchainActions";
import { fetchData } from "../../redux/data/dataActions";
import React from "react";
import { Accordion, Card, Container, Row, Col } from "react-bootstrap";
import dcrc1 from "../../assets/images/FOND1.png";
import dcrc2 from "../../assets/images/fond3.png";
import dcrc3 from "../../assets/images/dcrc3.png";
import dcrc4 from "../../assets/images/reveal2.png";
import dcrc5 from "../../assets/images/dcrc5.png";
import dcrc6 from "../../assets/images/dcrc6.png";
import dcrc7 from "../../assets/images/dcrc7.png";
import key1 from "../../assets/images/RaceXRedOGAvax.mp4";
import reveal from "../../assets/images/LamboReveal.mp4";
import t1 from "../../assets/images/t1.png";
import t2 from "../../assets/images/t2.png";
import t3 from "../../assets/images/t3.png";
import t4 from "../../assets/images/t4.png";
import t5 from "../../assets/images/t5.png";
import t6 from "../../assets/images/t6.png";
import t7 from "../../assets/images/t7.png";
import t8 from "../../assets/images/t8.png";
import t9 from "../../assets/images/t9.png";
import b1 from "../../assets/images/c1.png";
import b2 from "../../assets/images/c2.png";
import b3 from "../../assets/images/c3.png";
import b4 from "../../assets/images/c4.png";
import b5 from "../../assets/images/c5.png";
import b6 from "../../assets/images/c6.png";
import b7 from "../../assets/images/c7.png";
import b8 from "../../assets/images/c8.png";
import b10 from "../../assets/images/RaceXbanner1.png";
import b11 from "../../assets/images/RaceXbanner2.png";
import homeLogo from "../../assets/images/RaceXbanner1.png";
import Particle from "../Particle"; 
import Button from "react-bootstrap/Button";
import { BiLinkExternal } from "react-icons/bi";
import rp from "../../assets/images/dcrclogo.png";
import { FaTelegramPlane, FaDiscord, FaTwitter } from "react-icons/fa";
import { Chrono } from "react-chrono";
import { VerticalTimeline, VerticalTimelineElement }  from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import {Carousel} from '3d-react-carousal';
import ScrollToTop from "../ScrollToTop";
// import AccordionDisplay from "./Accordion";
import Footer from "../Footer";
import ReactPlayer from 'react-player';
import introvid from "../../assets/images/introvid.mp4"; 


function Home() {

  const dispatch = useDispatch();
  const blockchain = useSelector((state) => state.blockchain);
  const data = useSelector((state) => state.data);
  const [expand, updateExpanded] = useState(false);
  const [navColour, updateNavbar] = useState(false);
  const [walletAddress, setWallet] = useState("");
  const [claimingRewards, setClaimingRewards] = useState(false);
 
  useEffect( () => { 
    async function getWallet() {
      dispatch(connect());
    if(blockchain.account !== null){
          setWallet(blockchain.account);
        }
    }
    getWallet();
  }, []);

  useEffect(() => {
    if(blockchain.account !== null){
          setWallet(blockchain.account);
    }
  }, [blockchain.account]);


  const ImgSlider = () => {
    let slides = [
        <img src={b1} width="95%" height="95%" alt="1"/>,
        <img src={b2} width="95%" height="95%" alt="2"/>,
        <img src={b3} width="95%" height="95%" alt="3"/>,
        <img src={b4} width="95%" height="95%" alt="4"/>,
        <img src={b5} width="95%" height="50%" alt="5"/>,
        <img src={b6} width="95%" height="95%" alt="6"/>,
        <img src={b7} width="95%" height="50%" alt="6"/>,
        <img src={b8} width="95%" height="95%" alt="6"/>,
    ];
    return (
      <div style={{ width: "100%", height: "100%" }}>
            {/* <Carousel slides={slides} autoplay={true} interval={500} arrows={false}/> */}
            <Carousel slides={slides} autoplay={false}  className="caro-view"
            width={400}
            height={400}
            direction={'horizontal'}
            effect={'3d'}
            index={0}
/>
      </div>
      )
  }

  const [feedback, setFeedback] = useState("Mint your awesome RaceCar today...");
  const [nftsToBuy, setnftsToBuy] = useState(1);
  const [claimingNft, setClaimingNft] = useState(false);
  const [allMinted, setAllMinted] = useState(false);

  const claimNFTs = (_amount) => {
    if (_amount <= 0) {
      return;
    }
    setFeedback("Minting your DCRC RACE NFT...");
    setClaimingNft(true);
    blockchain.racexNFKEYNFT.methods
      .mint(blockchain.account, _amount)
      .send({
        // gasLimit: "500000",
        to: "0x...",
        from: blockchain.account,
        value: blockchain.web3.utils.toWei((data.cost * _amount).toString(), "ether"),
      })
      .once("error", (err) => {
        console.log(err);
        setFeedback("Sorry, something went wrong please try again later.");
        setClaimingNft(false);
      })
      .then((receipt) => {
        setFeedback(
          "WOW, you now own a DCRC NFT. View your NFTs on the MyNFTs page."
        );
        setClaimingNft(false);
        dispatch(fetchData(blockchain.account));
      });
  };

  const getData = () => {
    if (blockchain.account !== "" && blockchain.coolCowsNFT !== null) {
      dispatch(fetchData(blockchain.account));
    }
  };

  useEffect(() => {
    getData();
    if(data.totalSupply == data.maxSupply){
      setAllMinted(true);
    }
  }, [blockchain.account]);

  const incNFTs = () => {
    if(nftsToBuy < data.maxMintAmount){
      setnftsToBuy(nftsToBuy+1);
    }
  }

  const decNFTs = () => {
    if(nftsToBuy > 1){
      setnftsToBuy(nftsToBuy-1);
    }
  }

  const claimRoyalties = () => {
    console.log("Claiming Royalties");
    setFeedback("Claiming your RaceX Royalties...");
    setClaimingRewards(true);
    blockchain.racexNFKeyRoyaltyReceiver.methods
      .claimReflection(data.royalties)
      .send({
        gasLimit: "300000",
        to: "0x...",
        from: blockchain.account,
      })
      .once("error", (err) => {
        console.log(err);
        setFeedback("Sorry, something went wrong please try again later.");
        setClaimingRewards(false);
      })
      .then((receipt) => {
        setFeedback(
          "WOW, you got some rewards."
        );
        blockchain.racexNFKEYNFT.methods
          .claimReflectionRewards()
          .send({
            // gasLimit: "300000",
            to: "0x...",
            from: blockchain.account,
          })
          .once("error", (err) => {
            console.log(err);
            setFeedback("Sorry, something went wrong please try again later.");
            setClaimingRewards(false);
          })
          .then((receipt) => {
            setFeedback(
              "WOW, you got some rewards."
            );
          });
        setClaimingRewards(false);
        dispatch(fetchData(blockchain.account));
      });
      dispatch(fetchData(blockchain.account));
  };


  return (
    <section>
      <Container fluid className="home-section" id="#">
        <Container className="home-content">
        <Row style={{ justifyContent: "center", background: "white"}}>
          <Col md={12} style={{ justifyContent: "center", paddingBottom: "10px", paddingLeft: "75px", }}>
            <h1 className="home-heading">
              <strong className="black">MINT your nfkey today</strong>
            </h1>
            <h1 className="home-heading">
              <strong className="black">claim your car at the next drop</strong>
            </h1>
            <h1 className="home-heading">
              <strong className="red">racex community</strong>
            </h1>

            <Button  id="walletButton" className="wallet-button" 
              onClick={(e) => {
                e.preventDefault();
                dispatch(connect());
              //  getData();
              }}>
              {walletAddress.length > 0 ? (
                "Connected: " +
                String(walletAddress).substring(0, 6) +
                "..." +
                String(walletAddress).substring(38)
              ) : (
                <span>Connect Metamask</span>
              )}
            </Button>

          </Col>
          </Row>

          <Row style={{ justifyContent: "left", paddingBottom: "10px", paddingTop: "10px", paddingLeft: "75px", backgroundImage: `url(${dcrc1})` }}>
            <Col md={12}>
            <h1 className="home-heading">
              <strong className="white">The NFKeys</strong>
            </h1>
              <p>
              <span className="home-about-body">2000 nfkeys as a presale for our amazing cars nft</span><br/>
              <span className="home-about-body">- 3% reflection on  nfkey sale</span><br/>
              <span className="home-about-body">- claim a car nft at next drop for free while holding nfkey</span><br/>
              <span className="home-about-body">- there may never be another nfkey drop</span><br/>
              </p>
              <br/>
              </Col>
          </Row>
          <Row style={{ justifyContent: "left", paddingBottom: "10px", paddingTop: "20px", paddingLeft: "75px", background: "white" }}>
            <Col md={6} style={{ justifyContent: "center", paddingBottom: "10px", paddingTop: "10px" }}>
            <ReactPlayer url={key1} controls={true} playing={true} loop={true} width={400} height={300} />
            </Col>
            <Col md={6} style={{ justifyContent: "left", paddingBottom: "10px", paddingTop: "100px" }}>
                {/* <div id="my-group" class="input-group">
                    <label class="white">{data.royalties / 10**18} AVAX</label>
                    <div class="input-group-append">
                        <Button class="btn btn-outline-secondary" type="button" onClick={(e) => {
                          e.preventDefault();
                          claimRoyalties();
                          }}
                        >
                        Claim</Button>
                    </div>
                </div> */}
                  {/* <span class="black">{data.totalSupply} of {data.maxSupply}</span><br/> */}
                  <span class="black">1745 nfkeys Minted</span><br/>
                  <span class="black">NFKey Presale has ended</span><br/>
                {/* <Button variant="number" 
                // disabled={claimingNft || allMinted ? 1 : 0}
                      onClick={(e) => {
                        e.preventDefault();
                        decNFTs();
                      }}
>
                {claimingNft ? "-" : "-"}
                </Button>
                <Button variant="primary" disabled={claimingNft ? 1 : 0}
                      onClick={(e) => {
                        e.preventDefault();
                        claimNFTs(nftsToBuy);
                        getData();
                      }}
>
                {claimingNft ? "BUSY" : "Mint " + nftsToBuy}
                </Button>
                <Button variant="number" 
                // disabled={claimingNft ? 1 : 0}
                      onClick={(e) => {
                        e.preventDefault();
                        incNFTs();
                      }}
>
                {claimingNft ? "+" : "+"}
                </Button> */}

            </Col>
          </Row>

          <Row style={{ paddingBottom: "10px", paddingTop: "10px", paddingLeft: "75px", backgroundImage: `url(${dcrc2})` }}>
            <Col md={12} style={{ justifyContent: "right"}} >
              <span className="home-about-body-right-h">
                DCRC racex
              </span><br/>
              <span className="home-about-body-right">
                decentralized racing
              </span><br/>
              <span className="home-about-body-right">
                will be the first decentralized racing platform on avalanche
              </span><br/>
              <span className="home-about-body-right">
                a race to earn game that will allow virtual vs virtual
              </span><br/>
              <span className="home-about-body-right">
                real vs real and real vs virtual racing
              </span><br/><br/>
              <span className="home-about-body-right">
                $racex token is both the governance token of the project
              </span><br/>
              <span className="home-about-body-right">
                and also the currency that will be used in-game for
              </span><br/>
              <span className="home-about-body-right">
                upgrades, maintaining your car, racing, bets....
              </span><br/>
            </Col>
          </Row>

          <Row style={{ justifyContent: "left", paddingBottom: "10px", paddingTop: "20px", paddingLeft: "75px", background: "white" }}>
            <Col md={6} style={{ justifyContent: "center", paddingBottom: "10px", paddingTop: "10px" }}>
            <ReactPlayer url={reveal} controls={true} playing={true} loop={true} width={400} height={300} />
            </Col>
            <Col md={6} style={{ justifyContent: "left", paddingBottom: "10px", paddingTop: "10px" }}>
                  <span class="black">the cars nft drop will</span><br/>
                  <span class="black">occur q4 2021</span><br/><br/>
                  <span class="black">you will be able to claim a</span><br/>
                  <span class="black">free car per nfkey that you hold out of</span><br/>
                  <span class="black">the 10000 available to mint</span><br/><br/>
                  <span class="black">these cars will be playable</span><br/>
                  <span class="black">in-game / roadmapped q1 2022</span><br/>

            </Col>
          </Row>

          <Row style={{ justifyContent: "left", paddingBottom: "10px", paddingTop: "10px", paddingLeft: "75px",  background: "#2e2e2e"  }}>
            <Col md={6}>
            <h1 className="home-heading">
              <strong className="white">ROADMAP</strong>
            </h1>
              <span className="red">q4 2021</span><br/>
              <span className="white">racex goes live</span><br/>
              <span className="white">first release of racex website</span><br/>
              <span className="white">launch of $racex token</span><br/>
              <span className="white">nfkey presale launch</span><br/>
              <span className="white">race cars series 1 nft launch</span><br/>
              <span className="white">race cars reveal</span><br/><br/>
              <span className="red">q1 2022</span><br/>
              <span className="white">nft staking</span><br/>
              <span className="white">nft trading card game</span><br/>
              <span className="white">virtual racing practice app</span><br/>
              <span className="white">virtual racing championship series</span><br/>
              <span className="white">release of virtual racing app v1</span><br/>
              <span className="white">nft holders will be able to race each other</span><br/>
              <span className="white">boost stats and value</span><br/>
              <span className="white">set records</span><br/>
            </Col>
            <Col md={6} style={{ justifyContent: "left", paddingBottom: "10px", paddingTop: "10px", backgroundImage: `url(${dcrc4})` }}>

            </Col>
          </Row>

          <Row style={{ justifyContent: "left", paddingBottom: "10px", paddingTop: "10px", background: "white" }}>
            <Col md={6}>
              <br/>
              <br/>
              <br/>
              <br/>
              <br/>
              <h1 className="home-heading">
                <strong className="black-large">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;FAQ</strong>
              </h1>
             </Col>
            <Col md={6}>
              <br/>
              <p>
              <span className="black-bold">What can I do with my racex NFKey</span><br/>
              <span className="black-plain">you are free to do anything with your key</span><br/>
              <span className="black-plain">including holding, trading and keeping it for car minting</span><br/>
              </p>
              <p>
              <span className="black-bold">how much does it cost to mint?</span><br/>
              <span className="black-plain">- minting an nfkey costs 2 avax per unit and avalanche network will charge a small fee for tx fees</span><br/>
              <span className="black-plain">- minting price of the cars will be announced later</span><br/>
              </p>
            </Col>
          </Row>




          <div style={{ borderTop: "4px solid red ", marginLeft: 20, marginRight: 20 }}>
          </div>


          <Row style={{ justifyContent: "center", paddingTop: "100px", paddingBottom: "10px" }}></Row>
          <Footer />
        </Container>
        <Particle/>
      </Container>
    </section>
  );
}

export default Home;
